import { Box } from '@chakra-ui/react';
import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import LogoLoader from 'components/Loader/LogoLoader';

// import CompanySettingsRouter from './CompanySettingsRouter';
import VerticalSettingsTabs from './VerticalSettingsTabs';

const CompanySettings: React.FC<unknown> = () => {
  return (
    <Box
      position="relative"
      pb="4"
      mx={{ base: 0, md: 6 }}
      my={{ base: 6, md: 6 }}
      bg="white"
      minHeight="100%"
      padding={{ base: '1rem', md: '24px 0 40px 24px' }}
      borderRadius="lg"
    >
      <Box
        display={{ lg: 'grid' }}
        gridTemplateColumns={{ base: '1fr', lg: '210px 1fr' }}
        minHeight={{ base: 'initial', lg: '80vh' }}
      >
        <VerticalSettingsTabs />
        {/* <CompanySettingsRouter /> */}
        <Box
          minHeight="100%"
          minWidth="100%"
          padding={{ base: '0', sm: '0 1rem', lg: '0 20px 28px 40px' }}
          mt={{ base: '4', lg: '0' }}
        >
          <Suspense fallback={<LogoLoader />}>
            <Outlet />
          </Suspense>
        </Box>
      </Box>
    </Box>
  );
};

export default CompanySettings;
